import axios from 'axios';
import settings from '@/settings';
import store from '@/store';

/**
 * plataformas-apiv2: `GET /meetings`, `GET /recordings`.
 */
const instance = axios.create({
  baseURL: settings.api.plataformas.server,
  headers: settings.api.plataformas.headers,
});

instance.interceptors.request.use(async (xhr) => {
  const authUser = store.state.AuthFirebase.auth.currentUser;

  if (authUser) {
    // eslint-disable-next-line no-param-reassign
    xhr.headers.Authorization = `Bearer ${await authUser.getIdToken()}`;
  }

  return xhr;
});

/**
 * Reject and let the caller degrade.
 */
instance.interceptors.response.use(
  (xhr) => xhr,
  (error) => Promise.reject(error),
);

export default instance;
